export type DebouncedFn<TArgs extends any[]> = (...args: TArgs) => void;

// Worker-safe debounce helper (mirrors ~/Tools.js debounce semantics but without importing UI code).
export function debounce<TArgs extends any[]>(
  func: (...args: TArgs) => void,
  delay = 100
): DebouncedFn<TArgs> {
  let timer: ReturnType<typeof setTimeout> | undefined;
  return (...args: TArgs) => {
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => func(...args), delay);
  };
}


